import React, { Fragment, useState, useEffect } from "react";
import Breadcrumb from "../../component/common/breadcrumb/breadcrumb";
import {
    Container,
    Row,
    Col,
    Card,
    CardHeader,
    CardBody,
    Button,
    Form,
    FormGroup,
    Label,
    Input,
    Table,
    Img
} from "reactstrap";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import { toast } from "react-toastify";
import axios from "axios";

const ValetUsers = () => {
    const [users, setUsers] = useState([]);
    const [editingUser, setEditingUser] = useState(null);
    const [nextId, setNextId] = useState(1);
    const [showForm, setShowForm] = useState(false);
    const [error, setError] = useState("");
    const [photoFile, setPhotoFile] = useState(null);

    // Cargar usuarios al montar el componente
    useEffect(() => {
        axios
            .get(`${process.env.REACT_APP_PUBLIC_SERVER}/api/customers`)
            .then((response) => {
                setUsers(response.data);
            })
            .catch((error) => {
                toast.error("Error cargando usuarios:", error);
            });
    }, []);

    // Manejar la subida de la foto
    const handlePhotoChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            if (file.size > 10 * 1024 * 1024) { // Limite de 10 MB
                alert("La imagen es demasiado grande. El tamaño máximo es 10 MB.");
                return;
            }
            const reader = new FileReader();
            reader.onloadend = () => {
                setPhotoFile(reader.result.split(',')[1]); // Base64 sin prefijo
            };
            reader.readAsDataURL(file);
        }
    };

    // Agregar usuario mediante la API
    const addUser = (newUser) => {
        axios
            .post(`${process.env.REACT_APP_PUBLIC_SERVER}/api/customers`, newUser)
            .then((response) => {
                setUsers([...users, response.data]);
                setShowForm(false);
                setError("");
            })
            .catch((error) => {
                toast.error("Error agregando usuario:", error);
                setError(error.response?.data?.message || "Error al agregar el usuario.");
            });
    };

    // Actualizar usuario mediante la API
    const updateUser = (updatedUser) => {
        axios
            .put(`${process.env.REACT_APP_PUBLIC_SERVER}/api/customers/${updatedUser.id}`, updatedUser)
            .then((response) => {
                setUsers(users.map((user) => (user.id === updatedUser.id ? response.data : user)));
                setShowForm(false);
                setError("");
            })
            .catch((error) => {
                toast.error("Error actualizando usuario:", error);
                setError(error.response?.data?.message || "Error al actualizar el usuario.");
            });
    };

    // Eliminar usuario mediante la API
    const deleteUser = (id) => {
        if (window.confirm("¿Estás seguro de que deseas eliminar este usuario?")) {
            axios
                .delete(`${process.env.REACT_APP_PUBLIC_SERVER}/api/customers/${id}`)
                .then(() => {
                    setUsers(users.filter((user) => user.id !== id));
                })
                .catch((error) => {
                    toast.error("Error eliminando usuario:", error);
                });
        }
    };

    // Manejar el envio del formulario
    const handleSubmit = (e) => {
        e.preventDefault();
        const formData = new FormData(e.target);
        const userData = {
            full_name: formData.get("full_name"),
            email: formData.get("email"),
            phone_number: formData.get("phone_number"),
            fiscal_identification: formData.get("fiscal_identification"),
            car_model: formData.get("car_model"),
            car_identification: formData.get("car_identification"),
            photo: photoFile || (editingUser ? editingUser.photo : null),
            password: formData.get("password"),
        };

        if (editingUser) {
            userData.id = editingUser.id;
            updateUser(userData);
        } else {
            addUser(userData);
        }
        e.target.reset();
    };

    return (
        <Fragment>
            <Breadcrumb parent="Dashboard" title="Usuarios de Valet" />
            <Container fluid={true}>
                {/* Botón para agregar usuario */}
                <Row>
                    <Col sm="12" className="text-right">
                        <Button
                            color="success"
                            onClick={() => {
                                setEditingUser(null);
                                setShowForm(true);
                                setError("");
                            }}
                        >
                            Agregar Usuario
                        </Button>
                    </Col>
                </Row>
                {/* Tabla de usuarios */}
                <Row>
                    <Col sm="12">
                        <Card>
                            <CardHeader>
                                <h5>Usuarios</h5>
                            </CardHeader>
                            <CardBody>
                                <Table>
                                    <thead>
                                        <tr>
                                            <th style={{ color: "black" }}>Foto</th>
                                            <th style={{ color: "black" }}>Nombre Completo</th>
                                            <th style={{ color: "black" }}>Correo Electrónico</th>
                                            <th style={{ color: "black" }}>Teléfono</th>
                                            <th style={{ color: "black" }}>Identificación Fiscal</th>
                                            <th style={{ color: "black" }}>Modelo del Auto</th>
                                            <th style={{ color: "black" }}>Identificación del Auto</th>
                                            <th style={{ color: "black" }}>Acciones</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {users.map((user) => (
                                            <tr key={user.id}>
                                                <td>
                                                    {user.photo ? (
                                                        <img src={`data:image/jpeg;base64,${user.photo}`} alt="Foto del usuario" width="50" />
                                                    ) : (
                                                        "Sin foto"
                                                    )}
                                                </td>
                                                <td style={{ color: "black" }}>{user.full_name}</td>
                                                <td style={{ color: "black" }}>{user.email}</td>
                                                <td style={{ color: "black" }}>{user.phone_number}</td>
                                                <td style={{ color: "black" }}>{user.fiscal_identification}</td>
                                                <td style={{ color: "black" }}>{user.car_model}</td>
                                                <td style={{ color: "black" }}>{user.car_identification}</td>
                                                <td style={{ color: "black" }}>
                                                    <Button
                                                        color="primary"
                                                        onClick={() => {
                                                            setEditingUser(user);
                                                            setShowForm(true);
                                                            setError("");
                                                        }}
                                                        className="mr-2"
                                                    >
                                                        Editar
                                                    </Button>
                                                    <Button color="danger" onClick={() => {
                                                        if (window.confirm("¿Estás seguro de que deseas eliminar este usuario?")) {
                                                            deleteUser(user.id);
                                                        }
                                                    }}>
                                                        Eliminar
                                                    </Button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>

                {/* Formulario para agregar/editar usuario */}
                {showForm && (
                    <Row>
                        <Col sm="12">
                            <Card>
                                <CardHeader>
                                    <h5>{editingUser ? "Editar Usuario" : "Agregar Usuario"}</h5>
                                </CardHeader>
                                <CardBody>
                                    {error && <div className="alert alert-danger">{error}</div>}
                                    <Form onSubmit={handleSubmit} key={editingUser ? editingUser.id : "new"}>
                                        <FormGroup>
                                            <Label for="photo">Foto del Usuario</Label>
                                            <Input
                                                type="file"
                                                name="photo"
                                                id="photo"
                                                onChange={handlePhotoChange}
                                            />
                                        </FormGroup>
                                        <FormGroup>
                                            <Label for="full_name">Nombre Completo</Label>
                                            <Input
                                                type="text"
                                                name="full_name"
                                                id="full_name"
                                                defaultValue={editingUser ? editingUser.full_name : ""}
                                                placeholder="Ingrese el nombre completo"
                                                required
                                            />
                                        </FormGroup>
                                        <FormGroup>
                                            <Label for="email">Correo Electrónico</Label>
                                            <Input
                                                type="email"
                                                name="email"
                                                id="email"
                                                defaultValue={editingUser ? editingUser.email : ""}
                                                placeholder="Ingrese el correo electrónico"
                                                required
                                            />
                                        </FormGroup>
                                        <FormGroup>
                                            <Label for="password">Contraseña</Label>
                                            <Input
                                                type="password"
                                                name="password"
                                                id="password"
                                                placeholder="Ingrese contraseña"
                                                required
                                            />
                                        </FormGroup>
                                        <FormGroup>
                                            <Label for="phone_number">Teléfono</Label>
                                            <Input
                                                type="tel"
                                                name="phone_number"
                                                id="phone_number"
                                                defaultValue={editingUser ? editingUser.phone_number : ""}
                                                placeholder="Ingrese el número de teléfono"
                                                pattern="+[0-9]*"
                                                required
                                            />
                                        </FormGroup>
                                        <FormGroup>
                                            <Label for="fiscal_identification">Identificación Fiscal</Label>
                                            <Input
                                                type="text"
                                                name="fiscal_identification"
                                                id="fiscal_identification"
                                                defaultValue={editingUser ? editingUser.fiscal_identification : ""}
                                                placeholder="Ingrese la identificación fiscal"
                                                required
                                            />
                                        </FormGroup>
                                        <FormGroup>
                                            <Label for="car_model">Modelo del Auto</Label>
                                            <Input
                                                type="text"
                                                name="car_model"
                                                id="car_model"
                                                defaultValue={editingUser ? editingUser.car_model : ""}
                                                placeholder="Ingrese el modelo del auto"
                                                required
                                            />
                                        </FormGroup>
                                        <FormGroup>
                                            <Label for="car_identification">Identificación del Auto</Label>
                                            <Input
                                                type="text"
                                                name="car_identification"
                                                id="car_identification"
                                                defaultValue={editingUser ? editingUser.car_identification : ""}
                                                placeholder="Ingrese la identificación del auto"
                                                required
                                            />
                                        </FormGroup>
                                        <Button type="submit" color="success" className="mr-2">
                                            Guardar
                                        </Button>
                                        <Button type="button" color="secondary" onClick={() => setShowForm(false)} className="mr-2">
                                            Cancelar
                                        </Button>
                                        <Button type="reset" color="secondary">
                                            Limpiar
                                        </Button>
                                    </Form>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                )}
            </Container>
        </Fragment>
    );
};

export default ValetUsers;